import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const RevenuePage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Gelirler" />
      <div className="card">
        <div className="card-body">
          <h5>Gelirler</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default RevenuePage;

